import React from 'react';

export default function TopBar({ theme, onToggleTheme }) {
  const now = new Date();
  const etDate = now.toLocaleDateString('en-US', {
    timeZone: 'America/Toronto',
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });

  return (
    <div className="topbar-inner" style={{
      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      padding: '10px 20px',
      background: 'var(--surface)',
      borderBottom: '1px solid var(--border)',
      boxShadow: 'var(--card-shadow)'
    }}>
      <div style={{
        display: 'flex', alignItems: 'center', gap: '8px',
        fontSize: '17px', fontWeight: 600, color: 'var(--text)',
        letterSpacing: '-0.3px'
      }}>
        <div style={{
          width: '8px', height: '8px', borderRadius: '50%',
          background: 'var(--accent)', animation: 'blink 1.5s infinite'
        }} />
        ChartPulse Music
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <span className="topbar-timestamp" style={{ fontSize: '11px', color: 'var(--muted)' }}>
          Last updated: {etDate} at 9:00am ET &nbsp;|&nbsp; Next update: Tomorrow at 9:00am ET
        </span>
        <button onClick={onToggleTheme} style={{
          fontSize: '12px', padding: '4px 11px', borderRadius: '6px',
          border: '1px solid var(--border)', background: 'var(--surface)',
          color: 'var(--sub)', cursor: 'pointer'
        }}>
          <span className="topbar-theme-label">
            {theme === 'light' ? '☾ Dark mode' : '☀ Light mode'}
          </span>
          <span className="topbar-theme-icon" style={{ display: 'none' }}>
            {theme === 'light' ? '☾' : '☀'}
          </span>
        </button>
      </div>
    </div>
  );
}
